<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <mat-card class="mb-4">
        <mat-card-header>
          <mat-card-title>
            <mat-icon style="margin-right: 8px">notifications</mat-icon>
            Test des Notifications
          </mat-card-title>
          <mat-card-subtitle>
            Sélectionnez des rôles et une notification pour voir qui recevra
            l'email
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="row">
            <!-- Colonne gauche : Sélection -->
            <div class="col-md-4">
              <mat-card class="mb-4" style="background-color: #f5f5f5">
                <mat-card-header>
                  <mat-card-title style="font-size: 16px"
                    >1. Sélection des Rôles</mat-card-title
                  >
                </mat-card-header>
                <mat-card-content>
                  <div class="mb-3">
                    <button
                      mat-raised-button
                      color="primary"
                      style="width: 100%; margin-bottom: 12px"
                      (click)="toggleAllRoles()">
                      <mat-icon style="margin-right: 8px">{{
                        toggleAllButtonIcon
                      }}</mat-icon>
                      {{ toggleAllButtonText }}
                    </button>
                  </div>

                  <div
                    *ngIf="loadingRoles"
                    style="text-align: center; padding: 20px">
                    <mat-spinner diameter="30"></mat-spinner>
                    <p style="margin-top: 12px; color: #666">
                      Loading roles...
                    </p>
                  </div>

                  <div
                    *ngIf="!loadingRoles && allRoles.length === 0"
                    style="text-align: center; padding: 20px; color: #666">
                    <mat-icon
                      style="
                        font-size: 48px;
                        width: 48px;
                        height: 48px;
                        margin-bottom: 12px;
                        opacity: 0.5;
                      "
                      >info</mat-icon
                    >
                    <p>Aucun rôle trouvé</p>
                    <p style="font-size: 12px">
                      loadingRoles: {{ loadingRoles }}, allRoles.length:
                      {{ allRoles.length }}
                    </p>
                    <p style="font-size: 12px">
                      Vérifiez la console pour plus de détails
                    </p>
                  </div>

                  <div
                    *ngIf="!loadingRoles && allRoles.length > 0"
                    style="max-height: 400px; overflow-y: auto">
                    <div
                      *ngFor="let role of allRoles; let i = index"
                      class="role-item"
                      style="
                        padding: 8px;
                        margin-bottom: 8px;
                        background-color: white;
                        border-radius: 4px;
                      ">
                      <mat-checkbox
                        [checked]="role.selected"
                        (change)="
                          role.selected = !role.selected; updateSelectedRoles()
                        "
                        (click)="$event.stopPropagation()"
                        style="width: 100%">
                        <strong>{{ role.name }}</strong>
                        <span
                          *ngIf="role.description"
                          style="
                            color: #666;
                            font-size: 12px;
                            display: block;
                            margin-left: 24px;
                          ">
                          {{ role.description }}
                        </span>
                      </mat-checkbox>
                    </div>
                  </div>

                  <div
                    *ngIf="selectedRoles.length > 0"
                    style="
                      margin-top: 16px;
                      padding: 12px;
                      background-color: #e3f2fd;
                      border-radius: 4px;
                    ">
                    <strong
                      >{{ selectedRoles.length }} rôle(s) sélectionné(s)</strong
                    >
                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card style="background-color: #f5f5f5">
                <mat-card-header>
                  <mat-card-title style="font-size: 16px"
                    >2. Sélection de la Notification</mat-card-title
                  >
                </mat-card-header>
                <mat-card-content>
                  <div
                    *ngIf="loadingNotifications"
                    style="text-align: center; padding: 20px">
                    <mat-spinner diameter="30"></mat-spinner>
                    <p style="margin-top: 12px; color: #666">Chargement...</p>
                  </div>

                  <mat-form-field
                    *ngIf="!loadingNotifications"
                    appearance="outline"
                    style="width: 100%">
                    <mat-label>Notification</mat-label>
                    <mat-select
                      [(ngModel)]="selectedNotification"
                      (selectionChange)="onNotificationSelected()">
                      <mat-option
                        *ngFor="let notif of notifications"
                        [value]="notif">
                        {{ notif.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div
                    *ngIf="!loadingNotifications && notifications.length === 0"
                    style="
                      padding: 12px;
                      background-color: #fff3cd;
                      border-radius: 4px;
                      margin-top: 12px;
                    ">
                    <p style="margin: 0; color: #856404; font-size: 12px">
                      Aucune notification disponible
                    </p>
                    <p
                      style="
                        margin: 4px 0 0 0;
                        color: #856404;
                        font-size: 11px;
                      ">
                      loadingNotifications: {{ loadingNotifications }},
                      notifications.length: {{ notifications.length }}
                    </p>
                  </div>

                  <div
                    *ngIf="selectedNotification"
                    style="
                      margin-top: 12px;
                      padding: 12px;
                      background-color: white;
                      border-radius: 4px;
                    ">
                    <strong>{{ selectedNotification.name }}</strong
                    ><br />
                    <span style="color: #666; font-size: 12px">{{
                      selectedNotification.description
                    }}</span
                    ><br />
                    <span
                      *ngIf="
                        selectedNotification.requiredRoles &&
                        selectedNotification.requiredRoles.length > 0
                      "
                      style="
                        color: #666;
                        font-size: 12px;
                        margin-top: 8px;
                        display: block;
                      ">
                      Rôles requis:
                      <span
                        *ngFor="
                          let role of selectedNotification.requiredRoles;
                          let last = last
                        ">
                        <span
                          style="
                            background-color: #e3f2fd;
                            color: #1976d2;
                            padding: 2px 8px;
                            border-radius: 12px;
                            font-size: 11px;
                            margin-right: 4px;
                          "
                          >{{ role }}</span
                        >
                      </span>
                    </span>
                    <span
                      *ngIf="
                        !selectedNotification.requiredRoles ||
                        selectedNotification.requiredRoles.length === 0
                      "
                      style="
                        color: #4caf50;
                        font-size: 12px;
                        margin-top: 8px;
                        display: block;
                      ">
                      Affiché pour Tous
                    </span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <!-- Colonne droite : Liste des utilisateurs -->
            <div class="col-md-8">
              <mat-card>
                <mat-card-header>
                  <mat-card-title style="font-size: 16px">
                    <mat-icon style="margin-right: 8px">people</mat-icon>
                    Utilisateurs qui recevront la notification
                  </mat-card-title>
                  <div style="margin-left: auto">
                    <button
                      mat-raised-button
                      color="primary"
                      [disabled]="
                        !selectedNotification ||
                        selectedRoles.length === 0 ||
                        targetUsers.length === 0 ||
                        sending ||
                        loading
                      "
                      (click)="sendNotification()">
                      <mat-icon *ngIf="!sending" style="margin-right: 8px"
                        >send</mat-icon
                      >
                      <mat-spinner
                        *ngIf="sending"
                        diameter="20"
                        style="
                          display: inline-block;
                          margin-right: 8px;
                        "></mat-spinner>
                      {{
                        sending ? 'Envoi en cours...' : 'Envoyer Notification'
                      }}
                    </button>
                  </div>
                </mat-card-header>
                <mat-card-content>
                  <div
                    *ngIf="loading"
                    style="text-align: center; padding: 40px">
                    <mat-spinner diameter="40"></mat-spinner>
                    <p style="margin-top: 16px; color: #666">Chargement...</p>
                  </div>

                  <div
                    *ngIf="!loading && !selectedNotification"
                    style="text-align: center; padding: 40px; color: #666">
                    <mat-icon
                      style="
                        font-size: 48px;
                        width: 48px;
                        height: 48px;
                        margin-bottom: 16px;
                        opacity: 0.5;
                      "
                      >info</mat-icon
                    >
                    <p>Veuillez sélectionner une notification</p>
                  </div>

                  <div
                    *ngIf="
                      !loading &&
                      !loadingRoles &&
                      !loadingNotifications &&
                      selectedNotification &&
                      selectedRoles.length === 0
                    "
                    style="text-align: center; padding: 40px; color: #666">
                    <mat-icon
                      style="
                        font-size: 48px;
                        width: 48px;
                        height: 48px;
                        margin-bottom: 16px;
                        opacity: 0.5;
                      "
                      >badge</mat-icon
                    >
                    <p>
                      Veuillez sélectionner au moins un rôle pour voir les
                      utilisateurs
                    </p>
                    <p style="font-size: 12px; margin-top: 8px">
                      Cochez les rôles dans la colonne de gauche
                    </p>
                  </div>

                  <div
                    *ngIf="
                      !loading &&
                      !loadingRoles &&
                      !loadingNotifications &&
                      selectedNotification &&
                      selectedRoles.length > 0 &&
                      targetUsers.length === 0
                    "
                    style="text-align: center; padding: 40px; color: #666">
                    <mat-icon
                      style="
                        font-size: 48px;
                        width: 48px;
                        height: 48px;
                        margin-bottom: 16px;
                        opacity: 0.5;
                      "
                      >person_off</mat-icon
                    >
                    <p>
                      Aucun utilisateur ne correspond aux critères sélectionnés
                    </p>
                  </div>

                  <div
                    *ngIf="!loading && targetUsers.length > 0"
                    style="max-height: 600px; overflow-y: auto">
                    <div
                      class="mb-3"
                      style="
                        padding: 12px;
                        background-color: #e8f5e9;
                        border-radius: 4px;
                        margin-bottom: 16px;
                      ">
                      <strong
                        >{{ usersWillReceiveCount }} /
                        {{ targetUsers.length }} utilisateur(s) recevront la
                        notification</strong
                      >
                    </div>

                    <table
                      mat-table
                      [dataSource]="targetUsers"
                      class="mat-elevation-z2"
                      style="width: 100%">
                      <!-- Colonne Nom -->
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Nom</th>
                        <td mat-cell *matCellDef="let user">
                          {{ user.first_name }} {{ user.last_name }}
                        </td>
                      </ng-container>

                      <!-- Colonne Email -->
                      <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef>Email</th>
                        <td mat-cell *matCellDef="let user">
                          {{ user.email }}
                        </td>
                      </ng-container>

                      <!-- Colonne Rôles -->
                      <ng-container matColumnDef="roles">
                        <th mat-header-cell *matHeaderCellDef>Rôles</th>
                        <td mat-cell *matCellDef="let user">
                          <span
                            *ngFor="let role of user.roles; let last = last">
                            <span
                              style="
                                background-color: #e3f2fd;
                                color: #1976d2;
                                padding: 2px 8px;
                                border-radius: 12px;
                                font-size: 11px;
                                margin-right: 4px;
                              "
                              >{{ role }}</span
                            >
                          </span>
                        </td>
                      </ng-container>

                      <!-- Colonne Préférence -->
                      <ng-container matColumnDef="preference">
                        <th mat-header-cell *matHeaderCellDef>Préférence</th>
                        <td mat-cell *matCellDef="let user">
                          <mat-slide-toggle
                            [(ngModel)]="user.preferenceEnabled"
                            [disabled]="loading"
                            (toggleChange)="toggleUserPreference(user)">
                          </mat-slide-toggle>
                        </td>
                      </ng-container>

                      <!-- Colonne Statut -->
                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>
                          Recevra l'email
                        </th>
                        <td mat-cell *matCellDef="let user">
                          <mat-icon
                            [style.color]="
                              user.willReceive ? '#4caf50' : '#f44336'
                            ">
                            {{ user.willReceive ? 'check_circle' : 'cancel' }}
                          </mat-icon>
                          <span
                            [style.color]="
                              user.willReceive ? '#4caf50' : '#f44336'
                            "
                            style="margin-left: 8px">
                            {{ user.willReceive ? 'Oui' : 'Non' }}
                          </span>
                        </td>
                      </ng-container>

                      <tr
                        mat-header-row
                        *matHeaderRowDef="[
                          'name',
                          'email',
                          'roles',
                          'preference',
                          'status',
                        ]"></tr>
                      <tr
                        mat-row
                        *matRowDef="
                          let row;
                          columns: [
                            'name',
                            'email',
                            'roles',
                            'preference',
                            'status',
                          ]
                        "></tr>
                    </table>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
